<template>
  <!-- 水泵云知识库 -->
  <div class="knowledgeBase">
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <div class="container">
      <h2 style="margin-bottom: 0px">{{title1}}</h2>
      <div class="pump_knowledge">
        <div class="category-flex">
          <div class="noData" v-if="categories.length == 0">暂无数据</div>
          <div class="category-card" v-for="(item, index) in categories" :key="index">
            <div class="title">
              <span>{{ item.title }}</span>
              <span class="more" @click="knowledgeMore(item)">更多></span>
            </div>
            <div class="content">
              <div class="item" v-for="(el,i) in item.dataList" :key="i" @click="detail(el)">
                <div class="item-name over-num-lines">{{ el.title }}</div>
                <div class="item-date">{{ el.createDate.split(' ')[0] }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rank-flex">
          <div class="rank-card" v-for="(item,index) in rankList" :key="index">
            <div class="rank-title">{{ item.title }}</div>
            <div class="rank-content">
              <div class="noData" v-if="item.dataList.length == 0">暂无数据</div>
              <div class="rank-item" v-for="(el,i) in item.dataList" :key="i" @click="detail(el)">
                <div class="rank-sort" :class="{'rank-red': i<3}">{{ i + 1 }}</div>
                <div class="rank-name over-num-lines">{{ el.title }}</div>
                <div v-if="index == 0" class="rank-num">{{ el.pageViews }}</div>
                <div v-else-if="index == 1" class="rank-num">{{ el.likesNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2>{{title2}}</h2>
      <div class="pump_standard">
        <div class="standard-flex">
          <div class="noData" v-if="standardList.length == 0">暂无数据</div>
          <div
            class="standard-item"
            v-for="(item,index) in standardList"
            :key="index"
            @click="handlePreview(item)"
          >
            <div class="standard-item-img" :style="{ backgroundImage: `url(${bookImg})` }"></div>
            <div class="standard-item-name">{{ item.title }}</div>
          </div>
        </div>
        <div v-if="standardList.length > 0" class="standard-more" @click="standardMore">查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCategory,
  getDictionaryItem,
  getknowByUuid
} from "@/utils/interface.js";
import axios from "axios"; // 引入axios
export default {
  data() {
    return {
      headerBgUrl: require("../../assets/knowledge.jpg"),
      title1: "水泵知识",
      title2: "水泵标准",
      categories: [
        // {
        //   title: "材料",
        //   uuid: "001",
        //   dataList: [
        //     {
        //       title: "多级离心泵抗磨蚀涂层特点及工艺要求",
        //       createDate: "2025-01-10"
        //     },
        //     {
        //       title: "多级离心泵抗磨蚀涂层特点及工艺要求",
        //       createDate: "2025-01-10"
        //     },
        //     {
        //       title: "多级离心泵抗磨蚀涂层特点及工艺要求",
        //       createDate: "2025-01-10"
        //     }
        //   ]
        // }
      ],
      rankList: [
        {
          title: "点击排行",
          dataList: []
        },
        {
          title: "点赞排行",
          dataList: []
        }
      ],
      bookImg: require("../../assets/book.jpg"),
      standardList: [
        // {
        //   title: "GTB 42138-2022 流程型智能制造能力建设"
        // },
        // {
        //   title: "GTB 42138-2022 流程型智能制造能力建设"
        // },
        // {
        //   title: "GTB 42138-2022 流程型智能制造能力建设"
        // },
        // {
        //   title: "GTB 42138-2022 流程型智能制造能力建设"
        // }
      ]
    };
  },
  mounted() {
    // //顶部轮播图
    // getDictionaryItem({
    //   code: "ZWXX_BANNER"
    // }).then(res => {
    //   if (res != null && res.length > 0) {
    //     this.headerBgUrl = res[0].value;
    //   } else {
    //     this.headerBgUrl = "";
    //   }
    // });
    this.getCategory();
    this.getClickRank();
    this.getGoodRank();
  },
  methods: {
    /* 获取只是分类 */
    getCategory() {
      getCategory({
        current: 1,
        pageSize: 6
      }).then(res => {
        this.title1 = res[0].title;
        this.title2 = res[1].title;
        this.categories = res[0].children.map(item => {
          return {
            ...item,
            dataList: []
          };
        });
        this.getStandardByUuid(res[1].uuid); // 获取水泵标准列表
        // console.log(this.categories);
        this.$nextTick(() => {
          this.categories.forEach(item => {
            this.getknowByUuid(item.uuid);
          });
        });
      });
    },
    /* 获取某种分类的知识列表 */
    getknowByUuid(uuid) {
      getknowByUuid({
        current: 1,
        pageSize: 6,
        programUuid: uuid
      }).then(res => {
        this.categories.map(item => {
          if (item.uuid == uuid) {
            console.log("item__", item, res);
            item.dataList = res.data;
          }
        });
        // console.log(this.categories);
      });
    },
    /* 获取水泵标准的列表 */
    getStandardByUuid(uuid) {
      getknowByUuid({
        current: 1,
        pageSize: 4,
        programUuid: uuid
      }).then(res => {
        this.standardList = res.data;
      });
    },
    /* 获取点击排行榜 */
    getClickRank() {
      getknowByUuid({
        current: 1,
        pageSize: 10,
        sorterViewDesc: true
      }).then(res => {
        this.rankList[0].dataList = res.data;
      });
    },
    /* 获取点赞排行榜 */
    getGoodRank() {
      getknowByUuid({
        current: 1,
        pageSize: 10,
        sorterLikeDesc: true
      }).then(res => {
        this.rankList[1].dataList = res.data;
      });
    },
    /* 知识列表 */
    knowledgeMore(item) {
      let router = this.$router.resolve({
        path: "./knowledgeList",
        query: { uuid: item.uuid }
      });
      window.open(router.href, "_blank");
    },
    /* 知识详情 */
    detail(item) {
      let router = this.$router.resolve({
        path: "./knowledgeDetail",
        query: { uuid: item.uuid }
      });
      window.open(router.href, "_blank");
    },
    /* 标准列表 */
    standardMore() {
      let router = this.$router.resolve({
        path: "./standardList"
      });
      window.open(router.href, "_blank");
    },
    /* 预览 */
    handlePreview(row) {
      let fileExtension = row.file.split(".").pop();
      if (fileExtension == "pdf") {
        // https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-12-07%2F24efd210b42d4884a4ea95d5354d2403.pdf
        axios.get(row.file, { responseType: "blob" }).then(data => {
          let responseData = data.data;
          let blob = new Blob([responseData], {
            type: "application/pdf;charset=utf-8"
          });
          const href = URL.createObjectURL(blob);
          window.open(href, "newWindow");
        });
      } else {
        this.$message({
          message: "只能预览pdf文件",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
@basic-colors: #009999;
.knowledgeBase {
  background-color: #ffffff;
  .noData {
    color: #888;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;
    h2 {
      text-align: center;
      margin: 20px 0;
    }
    .pump_knowledge {
      display: grid;
      grid-template-columns: 2fr 0.8fr;
      grid-gap: 20px;
      .category-flex {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-content: start;
        box-sizing: border-box;
        position: relative;
        .category-card {
          width: 410px;
          height: 250px;
          box-sizing: border-box;
          border: 1px solid #d7d7d7;
          border-radius: 8px;
          margin-top: 20px;
          display: flex;
          flex-flow: column nowrap;
          justify-content: space-between;
          .title {
            height: 34px;
            line-height: 34px;
            padding: 0 15px;
            border-bottom: 1px solid #d7d7d7;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            font-weight: 600;
            .more {
              color: #888;
              cursor: pointer;
              font-weight: normal;
            }
          }
          .content {
            flex: 1;
            display: flex;
            flex-flow: column nowrap;
            // justify-content: space-around;
            padding: 5px 0 10px 0;
            .item {
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
              height: 32px;
              line-height: 32px;
              cursor: pointer;
              padding-right: 5px;
              font-size: 14px;
              &:hover {
                color: @basic-colors;
              }
              .item-name {
                position: relative;
                width: 275px;
                padding-left: 20px;
                &::before {
                  content: "";
                  width: 4px;
                  height: 4px;
                  border-radius: 2px;
                  background-color: black;
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  left: 10px;
                }
              }
              .item-date {
              }
            }
          }
        }
      }
      .rank-flex {
        display: flex;
        flex-flow: column nowrap;
        .rank-card {
          width: 320px;
          height: 380px;
          border: 1px solid #d7d7d7;
          border-radius: 8px;
          display: flex;
          flex-flow: column nowrap;
          margin-top: 20px;
          .rank-title {
            height: 40px;
            line-height: 40px;
            padding: 0 15px;
            border-bottom: 1px solid #d7d7d7;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            font-weight: 600;
          }
          .rank-content {
            flex: 1;
            display: flex;
            flex-flow: column nowrap;
            // justify-content: space-around;
            padding: 10px 0;
            position: relative;
            .rank-item {
              display: flex;
              flex-flow: row nowrap;
              height: 32px;
              line-height: 32px;
              cursor: pointer;
              padding-right: 5px;
              font-size: 14px;
              &:hover {
                color: @basic-colors;
              }
              .rank-sort {
                width: 34px;
                font-size: 18px;
                font-weight: 600;
                text-align: center;
                font-style: italic;
                color: #555555;
              }
              .rank-red {
                color: #d9001b;
              }
              .rank-name {
                flex: 1;
              }
              .rank-num {
                width: 45px;
                text-align: right;
              }
            }
          }
        }
      }
    }
    .pump_standard {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: center;
      .standard-flex {
        display: flex;
        flex-flow: wrap;
        justify-content: space-evenly;
        width: 100%;
        min-height: 200px;
        position: relative;
        .standard-item {
          width: 250px;
          display: flex;
          flex-flow: column nowrap;
          align-items: center;
          cursor: pointer;
          .standard-item-img {
            width: 160px;
            height: 220px;
            background-size: 100% 100%;
          }
          .standard-item-name {
            text-align: center;
            margin-top: 20px;
            color: #444;
            font-weight: bold;
          }
        }
      }
      .standard-more {
        margin: 20px auto;
        cursor: pointer;
        &:hover {
          color: @basic-colors;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/knowledgeBase/index.vue